import { canIUseTiktokSDK } from './utils';

export type ChannelNavigateToOptions = {
  url: string;
  redirect?: boolean;
  success?: (res?: any) => void;
  fail?: (err?: any) => void;
  complete?: (res?: any) => void;
};
export function channelNavigateTo(options: ChannelNavigateToOptions): void;
export function channelNavigateTo(url: string, options?: Omit<ChannelNavigateToOptions, 'url'>): void;
/**
 * navigateBack 目前仅用于抖音
 * @param delta 返回上一页面或多级页面 层级数量
 * @param options
 */
export function channelNavigateTo(
  delta: number,
  options?: Pick<ChannelNavigateToOptions, 'success' | 'fail' | 'complete'>,
): void;

export function channelNavigateTo(p1?: any, p2?: any) {
  if (canIUseTiktokSDK && tt && p1 != null) {
    if (typeof p1 === 'number') {
      tt.miniProgram.navigateBack({
        delta: p1,
        ...(p2 as Pick<ChannelNavigateToOptions, 'success' | 'fail' | 'complete'>),
      });
    } else {
      const _options = (typeof p1 === 'string' ? { url: p1, ...p2 } : p1) as ChannelNavigateToOptions;

      if (_options.redirect) {
        tt.miniProgram.redirectTo(_options);
      } else {
        tt.miniProgram.navigateTo(_options);
      }
    }
  }
}
